import Preloader from './dooh-react-utils/preload/Preloader';

export let icons = [
  [
    require('./assets/icons/01_A.png'),
    require('./assets/icons/01_B.png'),
    require('./assets/icons/01_C.png'),
    require('./assets/icons/01_D.png'),
  ],
  [
    require('./assets/icons/02_A.png'),
    require('./assets/icons/02_B.png'),
    require('./assets/icons/02_C.png'),
    require('./assets/icons/02_D.png'),
  ],
  [
    require('./assets/icons/03_A.png'),
    require('./assets/icons/03_B.png'),
    require('./assets/icons/03_C.png'),
    require('./assets/icons/03_D.png'),
  ],
  [
    require('./assets/icons/04_A.png'),
    require('./assets/icons/04_B.png'),
    require('./assets/icons/04_C.png'),
    require('./assets/icons/04_D.png'),
  ],
  [
    require('./assets/icons/05_A.png'),
    require('./assets/icons/05_B.png'),
    require('./assets/icons/05_C.png'),
    require('./assets/icons/05_D.png'),
  ],
];

export let results = [
  require('./assets/ID3.jpg'), // 0
  require('./assets/ID4.jpg'), // 1
  require('./assets/ID4GTX.jpg'), // 2
  require('./assets/ID5.jpg'), // 3
];

const preloader = new Preloader(
  [
    require('./assets/cta.jpg'),
    require('./assets/start.png'),
    require('./assets/bg.jpg'),
    require('./assets/loop.mp4'),
    ...results,
    ...icons[0],
    ...icons[1],
    ...icons[2],
    ...icons[3],
    ...icons[4],
  ],
  [
    { name: 'RegularFont', url: require('./assets/VWHead-Light.woff') },
    { name: 'BoldFont', url: require('./assets/VWHead-Bold.woff') },
  ]
);

export default preloader;
